import { Input } from '@dc-shared-web/components/shadcn'
import { faCopy } from '@document-crunch/pro-regular-svg-icons'

const ContextRow = ({ value }: { value: string }) => {
  const onCopy = async () => {
    const item = new window.ClipboardItem({
      'text/plain': new Blob([value], { type: 'text/plain' }),
    })
    await navigator.clipboard.write([item])
  }

  return (
    <div className='tw-flex tw-flex-col tw-gap-1'>
      <p className='tw-text-sm'>Context Used</p>
      <div className='tw-flex'>
        <Input
          value={value}
          disabled
          className='tw-grow'
          icon={faCopy}
          iconAction={onCopy}
        />
      </div>
    </div>
  )
}

export default ContextRow
